var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.dataLoading,
          expression: "dataLoading",
        },
      ],
      staticStyle: { height: "100%", width: "100%" },
      attrs: {
        "element-loading-text": _vm.$t("panel.data_loading"),
        "element-loading-spinner": "el-icon-loading",
        "element-loading-background": "rgba(220,220,220,1)",
      },
    },
    [
      _vm.panelInfo.name.length > 0
        ? _c(
            "el-col",
            { staticClass: "panel-design" },
            [
              _vm.showType === 2
                ? _c(
                    "el-row",
                    {
                      staticClass: "panel-design-head panel-share-head",
                      staticStyle: {
                        "border-bottom": "1px solid",
                        "border-bottom-color": "#E6E6E6",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { height: "100%" } },
                        [_c("share-head")],
                        1
                      ),
                    ]
                  )
                : _c(
                    "el-row",
                    {
                      staticClass: "panel-design-head",
                      staticStyle: {
                        "border-bottom": "1px solid",
                        "border-bottom-color": "#E6E6E6",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { height: "100%" } },
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: {
                                "text-overflow": "ellipsis",
                                overflow: "hidden",
                                "white-space": "nowrap",
                                "font-size": "14px",
                              },
                              attrs: { span: 12 },
                            },
                            [
                              _c("span", { staticClass: "panel-name" }, [
                                _vm._v(
                                  _vm._s(_vm.panelInfo.name || "测试仪表板")
                                ),
                              ]),
                              _vm.panelInfo.isDefault
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "green",
                                        "font-size": "12px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "(" +
                                          _vm._s(
                                            _vm.$t("panel.default_panel_name")
                                          ) +
                                          ":" +
                                          _vm._s(
                                            _vm.panelInfo.defaultPanelName
                                          ) +
                                          ")"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.panelInfo.sourcePanelName
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "green",
                                        "font-size": "12px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " (" +
                                          _vm._s(
                                            _vm.$t("panel.source_panel_name")
                                          ) +
                                          ":" +
                                          _vm._s(
                                            _vm.panelInfo.sourcePanelName
                                          ) +
                                          ")"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              !_vm.hasStar &&
                              _vm.panelInfo &&
                              _vm.showType !== 1 &&
                              _vm.panelInfo.status === "publish"
                                ? _c(
                                    "span",
                                    { staticStyle: { "margin-left": "9px" } },
                                    [
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content: _vm.$t("panel.store"),
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-star-off",
                                            on: { click: _vm.star },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.hasStar &&
                              _vm.panelInfo &&
                              _vm.showType !== 1 &&
                              _vm.panelInfo.status === "publish"
                                ? _c(
                                    "span",
                                    { staticStyle: { "margin-left": "9px" } },
                                    [
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              _vm.$t("commons.cancel") +
                                              _vm.$t("panel.store"),
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-star-on",
                                            on: { click: _vm.unstar },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.panelInfo.creatorName
                                ? [
                                    _c("el-divider", {
                                      staticStyle: { margin: "0 16px" },
                                      attrs: { direction: "vertical" },
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "panel-create" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t("panel.create_by") +
                                                ":" +
                                                _vm.panelInfo.creatorName
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                  ]
                                : _vm._e(),
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "right-start",
                                    width: "400",
                                    trigger: "click",
                                  },
                                },
                                [
                                  _c("panel-detail-info"),
                                  _c("svg-icon", {
                                    staticClass: "icon-class",
                                    staticStyle: {
                                      "margin-left": "4px",
                                      cursor: "pointer",
                                      "font-size": "14px",
                                    },
                                    attrs: {
                                      slot: "reference",
                                      "icon-class": "icon_info_outlined",
                                    },
                                    slot: "reference",
                                  }),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _vm.hasDataPermission(
                              "manage",
                              _vm.panelInfo.privileges
                            ) &&
                            _vm.activeTab === "PanelList" &&
                            !_vm.panelInfo.sourcePanelName
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      float: "right",
                                      "margin-right": "10px",
                                    },
                                  },
                                  [
                                    _c(
                                      "de-btn",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.editPanel },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(_vm.$t("commons.edit")) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.showType !== 1
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      float: "right",
                                      "margin-right": "10px",
                                    },
                                  },
                                  [
                                    _c(
                                      "de-btn",
                                      {
                                        attrs: { secondary: "" },
                                        on: { click: _vm.share },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(_vm.$t("panel.share")) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.panelInfo.status === "publish" &&
                            !_vm.isOtherPlatform
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      float: "right",
                                      "margin-right": "10px",
                                    },
                                  },
                                  [
                                    _c(
                                      "de-btn",
                                      {
                                        attrs: { secondary: "" },
                                        on: { click: _vm.clickFullscreen },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t("panel.fullscreen_preview")
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.activeTab !== "panels_star" ||
                            (_vm.activeTab === "panels_star" &&
                              _vm.panelInfo.status === "publish")
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "de-tree",
                                    staticStyle: {
                                      float: "right",
                                      "margin-right": "10px",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-dropdown",
                                      {
                                        attrs: {
                                          trigger: "click",
                                          size: "small",
                                          placement: "bottom-start",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "el-dropdown-link de-el-tree-node__content",
                                          },
                                          [
                                            _c("el-button", {
                                              attrs: {
                                                icon: "el-icon-more",
                                                type: "text",
                                                size: "small",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-dropdown-menu",
                                          {
                                            staticClass: "de-card-dropdown",
                                            attrs: { slot: "dropdown" },
                                            slot: "dropdown",
                                          },
                                          [
                                            _vm.panelInfo.status ===
                                              "publish" && !_vm.isOtherPlatform
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    nativeOn: {
                                                      click: function ($event) {
                                                        return _vm.newTab(
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("svg-icon", {
                                                      staticClass:
                                                        "preview-icon-svg",
                                                      attrs: {
                                                        "icon-class":
                                                          "icon_pc_outlined_copy",
                                                      },
                                                    }),
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "panel.new_tab_preview"
                                                          )
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                attrs: {
                                                  icon: "el-icon-refresh",
                                                },
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.refreshPanel(
                                                      $event
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "commons.refresh"
                                                      ) +
                                                        _vm.$t(
                                                          "chart.chart_data"
                                                        )
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                            _vm.hasDataPermission(
                                              "export",
                                              _vm.panelInfo.privileges
                                            ) &&
                                            _vm.panelInfo.status === "publish"
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    nativeOn: {
                                                      click: function ($event) {
                                                        return _vm.saveToTemplate(
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("svg-icon", {
                                                      staticClass:
                                                        "preview-icon-svg",
                                                      attrs: {
                                                        "icon-class":
                                                          "icon_yes_outlined",
                                                      },
                                                    }),
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "panel.save_to_panel"
                                                          )
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm.hasDataPermission(
                                              "manage",
                                              _vm.panelInfo.privileges
                                            ) &&
                                            _vm.activeTab === "PanelList" &&
                                            !_vm.panelInfo.sourcePanelName
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    nativeOn: {
                                                      click: function ($event) {
                                                        return _vm.changePublishState(
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("svg-icon", {
                                                      staticClass:
                                                        "preview-icon-svg",
                                                      attrs: {
                                                        "icon-class":
                                                          _vm.panelInfo
                                                            .status ===
                                                          "publish"
                                                            ? "cancel_release"
                                                            : "release",
                                                      },
                                                    }),
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "commons." +
                                                              (_vm.panelInfo
                                                                .status ===
                                                              "publish"
                                                                ? "unpublished"
                                                                : "publish")
                                                          )
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm.hasDataPermission(
                                              "export",
                                              _vm.panelInfo.privileges
                                            ) &&
                                            _vm.panelInfo.status === "publish"
                                              ? _c(
                                                  "el-dropdown",
                                                  {
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                    attrs: {
                                                      trigger: "hover",
                                                      placement: "right-start",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "el-dropdown-menu__item",
                                                      },
                                                      [
                                                        _c("svg-icon", {
                                                          staticClass:
                                                            "preview-icon-svg",
                                                          attrs: {
                                                            "icon-class":
                                                              "icon_bottom-align_outlined",
                                                          },
                                                        }),
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "log.export_as"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                        _c("svg-icon", {
                                                          staticClass:
                                                            "preview-icon-svg",
                                                          staticStyle: {
                                                            "margin-top": "7px",
                                                            float: "right",
                                                          },
                                                          attrs: {
                                                            "icon-class":
                                                              "icon_right_outlined",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-dropdown-menu",
                                                      {
                                                        staticClass:
                                                          "de-card-dropdown de-card-dropdown-right",
                                                        attrs: {
                                                          slot: "dropdown",
                                                        },
                                                        slot: "dropdown",
                                                      },
                                                      [
                                                        _c(
                                                          "el-dropdown-item",
                                                          {
                                                            attrs: {
                                                              icon: "el-icon-copy-document",
                                                            },
                                                            nativeOn: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.downloadToTemplate(
                                                                  $event
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "panel.export_to_panel"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "el-dropdown-item",
                                                          {
                                                            attrs: {
                                                              icon: "el-icon-notebook-2",
                                                            },
                                                            nativeOn: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.downloadAsPDF(
                                                                  $event
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "panel.export_to_pdf"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "el-dropdown-item",
                                                          {
                                                            attrs: {
                                                              icon: "el-icon-picture-outline",
                                                            },
                                                            nativeOn: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.downloadAsImage(
                                                                  $event
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "panel.export_to_img"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "el-dropdown-item",
                                                          {
                                                            attrs: {
                                                              icon: "el-icon-s-data",
                                                            },
                                                            nativeOn: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.downLoadToAppPre(
                                                                  $event
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "panel.export_to_app"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
              _c("el-row", { staticClass: "panel-design-preview" }, [
                _c(
                  "div",
                  {
                    ref: "imageWrapper",
                    style: _vm.imageWrapperStyle,
                    attrs: { id: "imageWrapper" },
                  },
                  [
                    _c(
                      "fullscreen",
                      {
                        staticStyle: {
                          height: "100%",
                          background: "#f7f8fa",
                          "overflow-y": "auto",
                        },
                        attrs: { fullscreen: _vm.fullscreen },
                        on: {
                          "update:fullscreen": function ($event) {
                            _vm.fullscreen = $event
                          },
                        },
                      },
                      [
                        _vm.showMainFlag
                          ? _c("Preview", {
                              ref: "paneViewPreviewRef",
                              attrs: {
                                "component-data": _vm.mainCanvasComponentData,
                                "canvas-style-data": _vm.canvasStyleData,
                                "active-tab": _vm.activeTab,
                                "in-screen": !_vm.fullscreen,
                                "show-type": "width",
                                "panel-info": _vm.panelInfo,
                                "screen-shot": _vm.dataLoading,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.panelInfo.name.length === 0
        ? _c(
            "el-col",
            { staticStyle: { height: "100%" } },
            [
              _c(
                "el-row",
                {
                  staticClass: "custom-position",
                  staticStyle: {
                    height: "100%",
                    "background-color": "var(--ContentBG)",
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("panel.select_panel_from_left")) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.templateSaveShow
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.$t("panel.save_to_panel"),
                visible: _vm.templateSaveShow,
                width: "500px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.templateSaveShow = $event
                },
              },
            },
            [
              _c("save-to-template", {
                attrs: { "template-info": _vm.templateInfo },
                on: { closeSaveDialog: _vm.closeSaveDialog },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.pdfExportShow
        ? _c(
            "el-dialog",
            {
              staticClass: "dialog-css2",
              attrs: {
                title:
                  "[" + _vm.panelInfo.name + "]" + _vm.$t("panel.pdf_export"),
                visible: _vm.pdfExportShow,
                width: "80%",
                top: "8vh",
                "destroy-on-close": true,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.pdfExportShow = $event
                },
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    position: "absolute",
                    right: "70px",
                    top: "15px",
                  },
                },
                [
                  _c("svg-icon", {
                    staticClass: "ds-icon-pdf",
                    attrs: { "icon-class": "PDF" },
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("panel.switch_pdf_template"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.changePdfTemplate()
                        },
                      },
                      model: {
                        value: _vm.pdfTemplateSelectedIndex,
                        callback: function ($$v) {
                          _vm.pdfTemplateSelectedIndex = $$v
                        },
                        expression: "pdfTemplateSelectedIndex",
                      },
                    },
                    _vm._l(_vm.pdfTemplateAll, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: index },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c("PDFPreExport", {
                attrs: {
                  snapshot: _vm.snapshotInfo,
                  "panel-name": _vm.panelInfo.name,
                  "template-content": _vm.pdfTemplateContent,
                },
                on: { closePreExport: _vm.closePreExport },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.appExportShow
        ? _c(
            "el-dialog",
            {
              staticClass: "dialog-css2",
              attrs: {
                title: _vm.$t("app_template.app_export"),
                visible: _vm.appExportShow,
                width: "80%",
                top: "8vh",
                "destroy-on-close": true,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.appExportShow = $event
                },
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    position: "absolute",
                    right: "70px",
                    top: "15px",
                  },
                },
                [
                  _c("svg-icon", {
                    staticClass: "ds-icon-pdf",
                    attrs: { "icon-class": "PDF" },
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("panel.switch_pdf_template"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.changePdfTemplate()
                        },
                      },
                      model: {
                        value: _vm.pdfTemplateSelectedIndex,
                        callback: function ($$v) {
                          _vm.pdfTemplateSelectedIndex = $$v
                        },
                        expression: "pdfTemplateSelectedIndex",
                      },
                    },
                    _vm._l(_vm.pdfTemplateAll, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: index },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c("PDFPreExport", {
                attrs: {
                  snapshot: _vm.snapshotInfo,
                  "panel-name": _vm.panelInfo.name,
                  "template-content": _vm.pdfTemplateContent,
                },
                on: { closePreExport: _vm.closePreExport },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          staticClass: "dialog-css",
          attrs: {
            title: _vm.authTitle,
            visible: _vm.authVisible,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.authVisible = $event
            },
          },
        },
        [
          _vm.authVisible
            ? _c("grant-auth", {
                attrs: { "resource-id": _vm.authResourceId },
                on: { "close-grant": _vm.closeGrant },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "keep-alive",
        [
          _c("app-export-form", {
            ref: "appExportForm",
            on: { downLoadApp: _vm.downLoadApp },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }